import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";



function DigitalMarketingPackages() {
  return (
    <>
      <Helmet>
        <title>Best Digital Marketing Packages in Ajman, Sharjah, Fujairah, Dubai, UAE</title>
        <meta name="description" content={"Our best digital marketing packages in Dubai are designed to increase website traffic, generate quality leads, and maximise your marketing ROI. Request a quote now."} />
        <meta name="keywords" content={"digital marketing packages in fujairah,Best digital marketing packages in Dubai,digital marketing packages in ajman,digital marketing packages in sharjah,digital marketing packages in abu dhabi,digital marketing packages in uae  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/digital-marketing-packages"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Digital Marketing Packages</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Digital Marketing Packages</li>
      </ul>
    </div>
  </div>
  <section style={{width: '100%', height: 200}}>
    <h1 style={{fontSize: 24, marginTop: 40, marginLeft: 70}}>Best Digital Marketing Packages in Abu Dhabi, Ajman, Sharjah, Fujairah, Dubai, UAE</h1>
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default DigitalMarketingPackages;
